import Styles from "./index.module.scss";
import clsx from "clsx";

export const SelectModal = ({ id, error, label, onChange, options, value }) => {
  return (
    <div className={clsx(Styles.wrapBox)}>
      <div className={clsx(Styles.wrapItem)}>
        <label className={clsx(Styles.label)} htmlFor={id}>
          {label}
        </label>

        <select
          id={id}
          className={clsx(Styles.type)}
          onChange={onChange}
          value={value}
        >
          {options.map((o, index) => {
            return (
              <option value={o.value} key={index}>
                {o.label}
              </option>
            );
          })}
        </select>
      </div>
      <span className={clsx(Styles.error)}>{error}</span>
    </div>
  );
};
